import Stack from '@mui/material/Stack';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import { CustomRadioGroupProps } from './types';

export function CustomRadioGroup<T>({
  onChange,
  label,
  options,
  defaultOption,
  disableDefaultOption,
  renderValue = (option) => (option as any).value,
  renderLabel = (option) => (option as any).label,
  ...props
}: CustomRadioGroupProps<T>): React.ReactElement {
  let defaultValue;
  const hasDefaultOption = defaultOption && !disableDefaultOption;

  if (hasDefaultOption) {
    defaultValue = renderValue(defaultOption) ?? (options[0] as any).value;
  }

  return (
    <FormControl>
      {options?.length > 0 && (
        <>
          {label && <FormLabel>{label}</FormLabel>}

          <RadioGroup defaultValue={defaultValue} {...props}>
            <Stack gap={1}>
              {options.map((option) => (
                <FormControlLabel
                  key={(option as any).id ? (option as any).id : renderValue(option)}
                  value={renderValue(option)}
                  onChange={() => onChange(option)}
                  label={renderLabel(option)}
                  control={<Radio color="default" />}
                  sx={{
                    border: '1px solid',
                    borderColor: 'var(--text-disabled)',
                    borderRadius: 1,
                  }}
                />
              ))}
            </Stack>
          </RadioGroup>
        </>
      )}
    </FormControl>
  );
}
